import { render } from "./BetModal.vue?vue&type=template&id=1188fcf2"
import script from "./BetModal.vue?vue&type=script&lang=js"
export * from "./BetModal.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./BetModal.vue?vue&type=style&index=0&id=1188fcf2&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__